<template>
    <div class="bg-white rounded-md overflow-hidden border border-keyline-primary hover:border-keyline-primary-invert">
        <button
            class="w-full px-5 py-4 flex justify-between items-center text-left"
            :aria-expanded="isOpen"
            :aria-controls="id"
            @click="isOpen = !isOpen"
        >
            <span class="font-medium pr-4 text-lg">{{ question }}</span>
            <BaseSvg
                :name="isOpen ? 'icon-expand-less' : 'icon-expand-more'"
                class="shrink-0 w-6 h-6"
            />
        </button>
        <div
            v-show="isOpen"
            :id="id"
            class="px-5 pb-4"
            :aria-hidden="!isOpen"
        >
            <p class="type-secondary leading-relaxed">{{ answer }}</p>
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue";
import { BaseSvg } from "@/Components";
import { v1 as uuidv1 } from "uuid";

const id = uuidv1();
const isOpen = ref(false);

defineProps({
    question: {
        type: String,
        required: true
    },
    answer: {
        type: String,
        required: true
    }
});
</script>
